import { radioGroupContext } from './chunk-4L7R5OAB.js';
import { setAttributeIfEmpty } from './chunk-Z6A4GYXE.js';
import { menuContext } from './chunk-HSL7QSWM.js';
import { __decorateClass } from './chunk-VPSTUDLO.js';
import { signal, provideContext, hasProvidedContext, effect, peek } from 'maverick.js';
import { defineElement, prop, Component } from 'maverick.js/element';

var RadioGroup = class extends Component {
  constructor(instance) {
    super(instance);
    this.Ka = /* @__PURE__ */ new Set();
    this.Y = signal("");
    this.jh = this.o.bind(this);
    provideContext(radioGroupContext, {
      add: this.hh.bind(this),
      remove: this.ih.bind(this)
    });
  }
  get values() {
    return Array.from(this.Ka).map((radio) => radio.Y());
  }
  get value() {
    return this.Y();
  }
  set value(value) {
    this.o(value);
  }
  onAttach(el) {
    const isMenuItem = hasProvidedContext(menuContext);
    if (!isMenuItem)
      setAttributeIfEmpty(el, "role", "radiogroup");
    this.Yd();
    this.setAttributes({ value: this.Y });
  }
  onConnect() {
    effect(this.Yd.bind(this));
  }
  onDestroy() {
    this.Ka.clear();
  }
  hh(radio) {
    if (this.Ka.has(radio))
      return;
    this.Ka.add(radio);
    radio.yb = this.jh;
    radio.bb(radio.Y() === this.Y());
  }
  ih(radio) {
    radio.yb = null;
    this.Ka.delete(radio);
  }
  Yd() {
    this.o(this.$props.value());
  }
  o(newValue, trigger) {
    const currentValue = peek(this.Y);
    if (!newValue || newValue === currentValue)
      return;
    const currentRadio = this.Zd(currentValue), newRadio = this.Zd(newValue);
    currentRadio?.bb(false, trigger);
    newRadio?.bb(true, trigger);
    this.Y.set(newValue);
    this.dispatch("change", { trigger });
  }
  Zd(newValue) {
    for (const radio of this.Ka) {
      if (newValue === peek(radio.Y))
        return radio;
    }
    return null;
  }
};
RadioGroup.el = defineElement({
  tagName: "media-radio-group",
  props: { value: "" }
});
__decorateClass([
  prop
], RadioGroup.prototype, "values", 1);
__decorateClass([
  prop
], RadioGroup.prototype, "value", 1);

export { RadioGroup };
